import { Button, Modal } from "react-bootstrap";
import './ReusableModal.css';

function ReusableModal({
    show,
    onHide,
    title,
    children,
    footer,
    closeLabel = "Close",
    size,
    centered = true,
    backdrop = true,
    keyboard = true,
    className = "",
    bodyClassName = "",
    footerClassName = "",
}) {
    const modalFooter = footer || (
        <Button variant="secondary" onClick={onHide}>
            {closeLabel}
        </Button>
    );

    return (
        <Modal
            show={show}
            onHide={onHide}
            size={size}
            centered={centered}
            backdrop={backdrop}
            keyboard={keyboard}
            className={`reusable-modal ${className}`.trim()}
        >
            <Modal.Header closeButton>
                {title && <Modal.Title>{title}</Modal.Title>}
            </Modal.Header>
            <Modal.Body className={bodyClassName}>
                {children}
            </Modal.Body>
            <Modal.Footer className={footerClassName}>
                {modalFooter}
            </Modal.Footer>
        </Modal>
    );
}

export default ReusableModal;
